export const Orientation = {
  HORIZONTAL: 'horizontal',
  VERTICAL: 'vertical',
} as const;

export type Orientation = Union<typeof Orientation>;
